import React from "react";
import { useSelector } from "react-redux";
import _ from "lodash";

import { limitString } from "../../helpers/format";
import Link from "../Link";
import Title from "../Title";
import Editor from "../Editor";
import ReadTime from "../ReadTime";
import Background from "../Background";
import ArticleSave from "../ArticleSave";
import CategoryList from "../CategoryList";

import style from "./style.module.css";

export default function RelativePostCard({ item = {}, className = "" }) {
    const userProfile = useSelector((state) => state.storage.data);
    if (!_.isEmpty(item)) {
        const { preview_image, name = "", time_duration = "", categories = [], short_description = "", url } = item;
        return (
            <div className={`${style.postCard} ${style.col3} ${style[className]}`}>
                <div className={style.postCardInner}>
                    <Link to={`/article/${url}`} className={style.postImage}>
                        <Background src={preview_image} size="330x270" />
                        <div className={style.postHeader}>
                            <ReadTime time={time_duration} />
                            <Title tag="h6" className="fontTeko">{limitString(name, 10, true)}</Title>
                        </div>
                    </Link>
                    <div className={style.postContent}>
                        <div className={style.postContentHeader}>
                            {
                                categories.length > 0 && (
                                    <CategoryList item={categories} tag="p" />
                                )
                            }
                            {
                                userProfile.id !== undefined && (
                                    <ArticleSave id={item._id} />
                                )
                            }
                        </div>
                        <div className={style.postContentBody}>
                            <Editor text={limitString(short_description)} />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}